import { render, staticRenderFns } from "./AppEnergielabelComponent.vue?vue&type=template&id=f0822608&scoped=true&"
import script from "./AppEnergielabelComponent.ts?vue&type=script&lang=ts&"
export * from "./AppEnergielabelComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppEnergielabelComponent.scss?vue&type=style&index=0&id=f0822608&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0822608",
  null
  
)

export default component.exports